import React, {useCallback, useState} from "react";
import api from "../../api";

export default function useMasterClasses() {

  const [isCreatingMasterClass, setIsCreatingMasterClass] = useState(false);
  const [isDeletingMasterClasses, setIsDeletingMasterClasses] = useState(false);

  const deleteMasterClasses = useCallback((idList) => {
    setIsDeletingMasterClasses(true);
    return Promise.all(idList.map(api.deleteMasterClass))
      .then(() => {
        setIsDeletingMasterClasses(false);
      }, () => {
        setIsDeletingMasterClasses(false);
      });
  }, [setIsDeletingMasterClasses]);

  const createMasterClass = useCallback((data) => {
    setIsCreatingMasterClass(true);
    return api.createMasterClass(data).then(() => {
      setIsCreatingMasterClass(false);
    }, () => {
      setIsCreatingMasterClass(false);
    });
  }, [setIsCreatingMasterClass]);

  return {
    createMasterClass,
    isCreatingMasterClass,
    deleteMasterClasses,
    isDeletingMasterClasses
  };
}
